<template lang="pug">
.dest-slides
  .swiper-container.dest
    .swiper-wrapper
      .swiper-slide.slide-0
      .swiper-slide.slide-1
      .swiper-slide.slide-2
      .swiper-slide.slide-3
      .swiper-slide.slide-4
    .swiper-pagination

</template>

<script>
import { Swiper, Pagination, Autoplay, EffectFade } from 'swiper/dist/js/swiper.esm.js'
import { mapState, mapMutations } from 'vuex'
import * as PATHS from 'src/router/paths'

export default {
  name: 'DestSlides',
  props:{
    dir: {
      default: 'vertical'
    }
  },
  components: {

  },
  data() {
    return {
      swiper: null
    }
  },
  computed: {
    ...mapState('app', ['showMenu'])
  },
  mounted() {
    Swiper.use([Pagination, Autoplay, EffectFade])
    this.init(this.dir)
    //console.log(702, this.swiper)
  },
  beforeDestroy() {
    this.swiper.destroy()
  },
  methods: {
    ...mapMutations('app', ['setMapProgress', 'setSceneProgress', 'setCurrSceneIdx']),
    enterScene(id){
      // this.$router.replace({
      //   name: PATHS.SCENES,
      //   params: {
      //     id: id,
      //   },
      // })
      this.$emit('selected', id)
    },
    init(dir){
      this.swiper = new Swiper('.dest', {
        //effect: 'coverflow',
        // effect: 'fade',
        // fadeEffect: {
        //   crossFade: true
        // },
        direction: dir,
        //direction: 'horizontal',
        shortSwipes: true,
        longSwipes: true,
        longSwipesRatio: 0.2,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        loop: false,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },

        on: {
          progress: (p) => {
            //console.log(555, p)
            this.setMapProgress(p)
            if (p > 1) {
              p = (p-1)*0.1+1
            }
            this.setSceneProgress(p*4/5)
          },
          slideChange: () => {
            //console.log('change', this.swiper.activeIndex)
            //this.currIdx = this.swiper.activeIndex
            this.$emit('sceneChange', this.swiper.activeIndex)
            this.setCurrSceneIdx(this.swiper.activeIndex)
            //console.log(this.currIdx)
          },
          touchStart: () => {
            this.$emit('touchStart')
          },
          touchEnd: () => {
            this.$emit('touchEnd')
          }
          // transitionStart: () => {
          //   //console.log('lalalalalalalaqlaqlqwllals,las')
          // }
        }
      })
    }
  },
  watch: {
    showMenu(val){
      if (val) {
        this.swiper.autoplay.stop()
      }else{
        this.swiper.autoplay.start()
      }
    }
    // dir(val){
    //   this.swiper.destroy()
    //   this.init(val)
    // }
  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
@import "src/styles/helpers/swiper.sass"
.dest-slides
  line-height: 0
  +full()

.dest
  +full()


.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet
  margin: 0 0.15rem !important
.swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet
  margin: 0.2rem 0 !important
.swiper-pagination-bullet

  path
    fill: white
.swiper-pagination-bullet-active
  path
    fill: $cl-yellow

/* Common Styles */
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets
  bottom: $ui-margin
  left: 0
  width: 100%

//.slide-1
  +full()
.swiper-slide
  width: 100%
  display: flex
  justify-content: center
  align-items: center
  img
    margin-top: -1.5rem
    display: block
    width: 2.5rem
    object-fit: cover



.copy
  line-height: 0.3rem
  z-index: 110
  width: 2rem
  height: auto
  object-fit: cover
  position: absolute
  left: 0.7rem
  bottom: $ui-margin-top + 0.5rem
  display: block
  font-size: 0.25rem



</style>
